import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import TicketResaleComponent from './js/ticket-resale.component';

ComponentsFactory.getInstance().define('ticket-resale', TicketResaleComponent);
